import membershipRepository from '@/repositories/membership.repository';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export function useMembershipMutation() {
  return useMutation({
    mutationFn: membershipRepository.membership,
  });
}

export function useConfirmSubscriptionMutation() {
  return useMutation({
    mutationFn: membershipRepository.confirmSubscription,
  });
}

export function useGetMembershipStatus(id: string) {
  return useQuery({
    queryKey: ['membership-status', 'get-membership-status', id],
    queryFn: () => membershipRepository.membershipStatus(id),
  });
}

export function useCancelSubscriptionMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => membershipRepository.cancelSubscription(id),
    onSuccess(_, id) {
      queryClient.invalidateQueries({ queryKey: ['membership-status', 'get-membership-status', id] });
      queryClient.invalidateQueries({ queryKey: ['me', 'get'] });
    },
  });
}

export function useRenewSubscriptionMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => membershipRepository.renewSubscription(id),
    onSuccess(_, id) {
      queryClient.invalidateQueries({ queryKey: ['membership-status', 'get-membership-status', id] });
      queryClient.invalidateQueries({ queryKey: ['me', 'get'] });
    },
  });
}

export function useGetPrice({ zip = null, coupon = null }: { zip: string | null; coupon: string | null }) {
  return useQuery({
    queryKey: ['get-price', zip, coupon],
    queryFn: () => membershipRepository.getPrice(zip, coupon),
  });
}

export function useJoinWaitlistV1Mutation() {
  return useMutation({
    mutationFn: (params: { email: string; accessCode?: string | null }) =>
      membershipRepository.joinWaitlistV1(params.email, params.accessCode),
  });
}

export function useCheckVipAccess() {
  return useQuery({
    queryKey: ['vip-access', 'check'],
    queryFn: () => membershipRepository.checkVipAccess(),
  });
}
